<template>
    <v-container :style="formattedStyle">
        <span v-if="showDate">{{ formattedDate }}</span>
        <span v-if="showDate && showClock"> - </span>
        <span v-if="showClock">{{ formattedTime }}</span>
    </v-container>
</template>

<script>
export default {
    name: "zoezi-clock-date",
    zoezi: {
        title: "Date and time",
        icon: "mdi-clock-time-four-outline",
    },
    props: {
        textSize: {
            title: "Text Size",
            type: String,
            fulltype: "csssize",
            default: "2rem",
        },
        showDate: {
            title: "Show Date",
            type: Boolean,
            section: "Date",
            default: true,
        },
        showDay: {
            title: "Show Day",
            type: Boolean,
            section: "Date",
            default: true,
        },
        showClock: {
            title: "Show time",
            type: Boolean,
            section: "Clock",
            default: true,
        },
        showSeconds: {
            title: "Show Seconds",
            type: Boolean,
            section: "Clock",
            default: true,
        },
    },
    data() {
        return {
            currentDateTime: new Date(),
            clockInterval: null,
        };
    },
    computed: {
        formattedDate() {
            const day = this.showDay ? this.$translate(this.currentDateTime.getWeekDayString()) : "";
            const date = this.currentDateTime.getDate();
            const month = this.$translate(this.currentDateTime.getMonthName());

            return `${day} ${date} ${month}`.trim();
        },
        formattedTime() {
            return this.showSeconds ? this.currentDateTime.hhmmss() : this.currentDateTime.hhmm();
        },
        formattedStyle() {
            return {
                fontSize: this.textSize,
            };
        },
    },
    methods: {
        startClock() {
            this.clockInterval = setInterval(() => {
                this.currentDateTime = new Date();
            }, 1000); // Update every second
        },
    },
    mounted() {
        this.startClock();
    },
    beforeDestroy() {
        if (this.clockInterval) {
            clearInterval(this.clockInterval);
        }
    },
};
</script>
